export const baseOptions = {
  credentials: 'same-origin',
  headers: {
    'Accept': 'application/json'
  }
};

export const baseUrl = '/domainservice/';

export default {
  baseOptions,
  baseUrl
};
